import React, { Fragment } from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { isPresent } from 'utils/helperMethods';
import LoanOfficerPresenter, { buildNmlsCheckingServiceLink } from 'presenters/LoanOfficerPresenter';
import UserImage from 'sharedComponents/UserImage';
import Icon from 'sharedComponents/Icon';

import useStyles from './useStyles';

const LoanOfficerInfoBar = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { loanOfficer } = props;

  const isLocationPresent = isPresent(LoanOfficerPresenter.location(loanOfficer));
  const isProfileDescriptionPresent = isPresent(LoanOfficerPresenter.aboutMe(loanOfficer));
  const isCompanyNmlsPresent = isPresent(LoanOfficerPresenter.companyNmls(loanOfficer));
  const nmlsCheckingServiceLink = buildNmlsCheckingServiceLink(LoanOfficerPresenter.nmls(loanOfficer));
  const companyNmlsCheckingServiceLink = buildNmlsCheckingServiceLink(LoanOfficerPresenter.companyNmls(loanOfficer));

  const loanOfficerCompanyNmlsContent = isCompanyNmlsPresent
    ? t('components.LoanOfficerInfo.nmlsWithCheckingServiceLink', {
        link: companyNmlsCheckingServiceLink,
        nmls: LoanOfficerPresenter.companyNmls(loanOfficer),
      })
    : t('components.LoanOfficerInfo.blankNmls');

  return (
    <Box className={classes.container}>
      <Box display="flex" width="100%">
        <UserImage imageUrl={LoanOfficerPresenter.profileImageUrl(loanOfficer)} />
        <Box width="100%" ml={4}>
          <Box width="100%" textOverflow="ellipsis" className={classes.name}>
            <Typography variant="h2">{LoanOfficerPresenter.fullName(loanOfficer)}</Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" color="secondary">
              {t('models.App.userTypes.loanOfficer')}
            </Typography>
          </Box>
          <Box mt={0.5}>
            <Typography
              variant="subtitle1"
              color="secondary"
              className={classes.textLink}
              dangerouslySetInnerHTML={{
                __html: t('components.LoanOfficerInfo.nmlsWithCheckingServiceLink', {
                  link: nmlsCheckingServiceLink,
                  nmls: LoanOfficerPresenter.nmls(loanOfficer),
                }),
              }}
            />
          </Box>
          <Box display="flex" width="100%" height={23} alignItems="center" mt={2}>
            <Box display="flex" alignItems="center">
              {isPresent(LoanOfficerPresenter.companyLogoUrl(loanOfficer)) && (
                <img
                  alt="company logo"
                  className={classes.companyLogo}
                  src={LoanOfficerPresenter.companyLogoUrl(loanOfficer)}
                />
              )}
            </Box>
            <Box width="100%" ml={1} textOverflow="ellipsis">
              <Typography variant="subtitle1" color="primary">
                {LoanOfficerPresenter.companyName(loanOfficer)}
              </Typography>
              <Typography
                variant="subtitle1"
                color="primary"
                className={classes.textLink}
                dangerouslySetInnerHTML={{ __html: loanOfficerCompanyNmlsContent }}
              />
            </Box>
          </Box>
          {isLocationPresent && (
            <Box mt={2} display="flex">
              <Icon name="point" />
              <Box ml={1}>
                <Typography variant="body2">{LoanOfficerPresenter.location(loanOfficer)}</Typography>
              </Box>
            </Box>
          )}
        </Box>
      </Box>
      <Box className={classes.divider} mt={4} />
      <Box display="flex" mt={4} alignItems="center">
        <Icon name="mail" className={classes.icon} />
        <Box ml={1} display="flex" alignItems="center">
          <Typography variant="body2">
            <a
              className={classes.contact}
              target="_blank"
              rel="noreferrer"
              href={`mailto:${LoanOfficerPresenter.email(loanOfficer)}`}
            >
              {LoanOfficerPresenter.email(loanOfficer)}
            </a>
          </Typography>
        </Box>
      </Box>
      {isProfileDescriptionPresent && (
        <Fragment>
          <Box className={classes.divider} mt={4} />
          <Box width="100%" mt={4} maxWidth={320}>
            <Typography variant="h2">{t('components.LoanOfficerInfo.aboutMe')}</Typography>
            <Typography variant="body2" className={classes.aboutMeText}>
              {LoanOfficerPresenter.aboutMe(loanOfficer)}
            </Typography>
          </Box>
        </Fragment>
      )}
    </Box>
  );
};

LoanOfficerInfoBar.propTypes = {
  loanOfficer: LoanOfficerPresenter.shape().isRequired,
};

export default LoanOfficerInfoBar;



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOfficerInfoBar/LoanOfficerInfoBar.js